import React from 'react'
import { Box, Icon } from '@maui/elements'
import { SearchResultDescription, SearchResultHeader, SearchResultPill, SearchResultPillMore, SearchResultTitle } from '../common'

export const MalwareSearchResult = ({ data }) => {
  const {
    id,
    name,
    last_activity_time: date,
    description,
    aliases = [],
    roles = []
  } = data
  return (
    <Box>
      <SearchResultHeader subHeaderText={'Malware'} date={date} />
      <SearchResultTitle
        titleIcon={<Icon name='bug' size='lg' verticalAlign='-12.7px'/>}
        name={name}
        url={`/malware/${id}`}
      />
      {
        aliases.length > 0 && (
          <Box pt='8px' pb='8px' width='80%'>
            <Box
              textStyle='caption'
              fontSize='10px'
              color='colorTextDeemphasis'
              textOverflow='ellipsis'
              overflow='hidden'
              whiteSpace='nowrap'
            >
              {aliases.map(alias => alias.name).join(', ')}
            </Box>
          </Box>
        )
      }
      <Box pt='8px' pb='8px'>
        <Box display='flex'>
          <Box>
            <SearchResultPill
              type={<Box textStyle='bodySmall'>Role:</Box>}
              value={
                <Box display='flex' gap='4px'>
                  <Box textStyle='buttonLabelSmall' display='flex' gap='4px'>
                    {roles[0]}
                  </Box>
                  <SearchResultPillMore values={roles}/>
                </Box>
              }
            />
          </Box>
        </Box>
      </Box>

      <SearchResultDescription description={description}/>
    </Box>
  )
}
